import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const StackedParcels: FC<SvgIconProps> = ({ viewBox = '0 0 255 170', ...props }) => (
  <SvgIcon viewBox={viewBox} fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.3"
      d="M92.6698 165.583L117.104 160.783L75.5437 140.057L51 144.966L92.6698 165.583Z"
      fill="url(#stackedParcels_paint0_linear)"
    />
    <path d="M117.104 95.115L190.19 82.025L148.63 61.2991L75.5437 74.3891L117.104 95.115Z" fill="#FDDE84" />
    <path
      opacity="0.4"
      d="M99.2149 86.1702L172.301 73.0802L165.428 69.6986L92.2335 82.6795L99.2149 86.1702Z"
      fill="#AA7B33"
    />
    <path d="M117.104 95.1149V160.783L75.5437 140.057V74.3891L117.104 95.1149Z" fill="#C39000" />
    <path opacity="0.4" d="M99.2149 86.1702V100.46L92.2335 96.8603V82.6795L99.2149 86.1702Z" fill="#AA7B33" />
    <path d="M117.104 95.115V160.783L190.19 147.693V82.025L117.104 95.115Z" fill="#FCCE09" />
    <path
      opacity="0.4"
      d="M136.085 91.7334V104.278L190.19 95.3332V82.025L136.085 91.7334Z"
      fill="url(#stackedParcels_paint1_linear)"
    />
    <path d="M201.753 75.1528L144.048 85.7338L85.9067 59.1175L143.612 48.3182L201.753 75.1528Z" fill="#FDDE84" />
    <path d="M144.048 95.3332L85.9067 68.7168V59.1175L144.048 85.7338V95.3332Z" fill="#C39000" />
    <path d="M201.753 84.7521L144.048 95.3332V85.7338L201.753 75.1528V84.7521Z" fill="#FCCE09" />
    <path
      opacity="0.4"
      d="M181.246 79.0797L169.901 81.1523L112.087 54.2087L123.213 52.1361L181.246 79.0797Z"
      fill="#AA7B33"
    />
    <path opacity="0.4" d="M169.901 81.1523V90.6426L181.246 88.57V79.0797L169.901 81.1523Z" fill="#AA7B33" />
    <path
      opacity="0.2"
      d="M120.268 94.5695L136.085 91.7334L92.0153 71.4439L78.7072 73.8437L120.268 94.5695Z"
      fill="url(#stackedParcels_paint2_linear)"
    />
    <path d="M125.395 32.6103L168.701 24.8653L144.048 12.648L100.851 20.3929L125.395 32.6103Z" fill="#634509" />
    <path d="M161.611 32.8284L168.701 24.8653L144.048 12.648L137.067 20.7202L161.611 32.8284Z" fill="#996A0D" />
    <path d="M125.395 32.6102L145.903 33.1557L121.25 20.9383L100.851 20.3929L125.395 32.6102Z" fill="#996A0D" />
    <path
      opacity="0.2"
      d="M110.996 74.3891L125.395 71.4439L100.851 59.2266L86.343 62.0627L110.996 74.3891Z"
      fill="url(#stackedParcels_paint3_linear)"
    />
    <path d="M125.395 32.6103V71.4439L100.851 59.2266V20.3929L125.395 32.6103Z" fill="#C39000" />
    <path d="M125.504 32.6102V71.4439L168.701 63.699V24.8653L125.504 32.6102Z" fill="#FCCE09" />
    <path d="M112.414 13.4116L155.611 5.66666L144.048 12.648L100.851 20.3929L112.414 13.4116Z" fill="#C39000" />
    <path d="M125.395 32.6102L168.701 24.8653L158.774 15.266L115.468 23.0109L125.395 32.6102Z" fill="#FDDE84" />
    <defs>
      <linearGradient
        id="stackedParcels_paint0_linear"
        x1="77.2828"
        y1="156.837"
        x2="83.8977"
        y2="142.721"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.25" stopOpacity="0" />
        <stop offset="0.598958" stopOpacity="0.3" />
        <stop offset="1" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        id="stackedParcels_paint1_linear"
        x1="164.792"
        y1="104.206"
        x2="160.622"
        y2="75.9406"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.27" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset="0.93" />
      </linearGradient>
      <linearGradient
        id="stackedParcels_paint2_linear"
        x1="101.52"
        y1="86.6457"
        x2="107.676"
        y2="74.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.25" stopOpacity="0" />
        <stop offset="0.598958" stopOpacity="0.3" />
        <stop offset="1" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        id="stackedParcels_paint3_linear"
        x1="101.87"
        y1="69.1938"
        x2="105.813"
        y2="60.8255"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.25" stopOpacity="0" />
        <stop offset="0.598958" stopOpacity="0.3" />
        <stop offset="1" stopOpacity="0.8" />
      </linearGradient>
    </defs>
  </SvgIcon>
)
